import { environment } from '../../environments/environment';

export interface NetworkConfig {
  chainId: number;
  chainName: string;
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  rpcUrls: string[];
  blockExplorerUrls: string[];
}

export const NETWORKS: Record<string, NetworkConfig> = environment.networkMode === 'TESTNET' ? {
  bnb: {
    chainId: 97,
    chainName: 'BNB Smart Chain Testnet',
    nativeCurrency: { name: 'Test BNB', symbol: 'tBNB', decimals: 18 },
    rpcUrls: [environment.rpcUrls[97] || 'https://data-seed-prebsc-1-s1.binance.org:8545'],
    blockExplorerUrls: ['https://testnet.bscscan.com'],
  },
  eth: {
    chainId: 11155111,
    chainName: 'Sepolia Testnet',
    nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: [environment.rpcUrls[11155111] || 'https://ethereum-sepolia-rpc.publicnode.com'],
    blockExplorerUrls: ['https://sepolia.etherscan.io'],
  },
  matic: {
    chainId: 80002,
    chainName: 'Polygon Amoy Testnet',
    nativeCurrency: { name: 'POL', symbol: 'POL', decimals: 18 },
    rpcUrls: [environment.rpcUrls[80002] || 'https://rpc-amoy.polygon.technology'],
    blockExplorerUrls: ['https://amoy.polygonscan.com'],
  }
} : {
  bnb: {
    chainId: 56,
    chainName: 'BNB Smart Chain Mainnet',
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
    rpcUrls: [environment.rpcUrls[56] || 'https://bsc-dataseed.binance.org/'],
    blockExplorerUrls: ['https://bscscan.com'],
  },
  eth: {
    chainId: 1,
    chainName: 'Ethereum Mainnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: [environment.rpcUrls[1] || 'https://eth.drpc.org'],
    blockExplorerUrls: ['https://etherscan.io'],
  },
  matic: {
    chainId: 137,
    chainName: 'Polygon Mainnet',
    nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
    rpcUrls: [environment.rpcUrls[137] || 'https://polygon.drpc.org'],
    blockExplorerUrls: ['https://polygonscan.com'],
  }
};

export const getNetworkConfigById = (id: string): NetworkConfig | undefined => {
  if (id === 'sepolia') return NETWORKS['eth'];
  if (id === 'amoy') return NETWORKS['matic'];
  return NETWORKS[id];
};

export const WALLET_CONNECT_PROJECT_ID = 'b5377a303f5f324ec8df9c4a80da6cf2';
